import React, { Component } from 'react';
import { Controller } from '../../common/Controller';
import { UiLoginHelper } from '../../common/helpers/UiLoginHelper';
import { Helper } from '../../common/helpers/Helper';
import { UsernameInput, PasswordInput, NumericOTPInput, PlainTextInput } from './TextInputsAdv';
import { StyleSheet, css } from 'aphrodite';

import { AppConfig } from '../../AppConfig';
import { AppTheme } from '../../styles/AppTheme'
import { HelmetComponent } from '../../common/components/HelmetComponent';
import { AppButton } from '../../common/components/AppButton';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { PhoneNumberHelper } from '../../common/helpers/PhoneNumberHelper';

export class LoginCustomAdv extends Component {
  constructor(props) {
    super(props);
    this.userNameType = AppConfig.USER_PRIMARY === 'email' ?
      UiLoginHelper.UserNameType.EMAIL : UiLoginHelper.UserNameType.PHONE
    this.loginParams = this.props.loginParams || {}
    this.state = {
      currentPage: this.props.showOrgSignup ? UiLoginHelper.Page.PROFILE_COMPLETION : UiLoginHelper.Page.LOOKUP,
      loadingAnimation: false,
      message: '',
      userName: '',
      pword: '',
      verificationCode: '',
      ac: this.loginParams.ac || ''
    };
    this.loginHelper = new UiLoginHelper(this, {
      autoSignUp: false,
      autoLogin: true,
      userNameType: this.userNameType,
      jsonBody: this.props.jsonBody ? this.props.jsonBody : {},
      onSuccessLogin: this.onSuccessLogin.bind(this)
    });
  }

  onSuccessLogin() {

    if (!Controller.get().userMgr().getAppUser().orgs || Controller.get().userMgr().getAppUser().orgs.length === 0) {
      this.setState({ currentPage: UiLoginHelper.Page.PROFILE_COMPLETION, loadingAnimation: false })
      return
    }
    Controller.get().userMgr().setGuestUser(false);
    if (this.props.onSuccessLogin) {
      this.props.onSuccessLogin()
      return
    }
    window.location.href = Controller.get().roleHelper().getHome()
  }

  onSelfOnBoard = () => {
    //console.log('onSelfOnBoard');
    let msg = ''
    if (!this.state.givenname) {
      msg = Helper.getString('enterGivenname')
    } else if (!this.state.familyname) {
      msg = Helper.getString('enterFamilyname')
    } else if (!this.state.title) {
      msg = Helper.getString('enterOrgTitle')
    }
    let phone = null
    if(this.state.phone) {
      try {
        phone = PhoneNumberHelper.formatNumber(this.state.phone, AppConfig.DEFAULT_COUNTRY);
      } catch (err) {
        msg = Helper.getString('enterValidPhone')
      }
    }
    if (msg) {
      this.setState({
        message: msg,
        loadingAnimation: false
      });
      return
    }
    this.setState({
      loadingAnimation: true
    });
    const jsonBody = {
      title: this.state.title,
      givenname: this.state.givenname,
      familyname: this.state.familyname,
    }
    if(this.state.phone) jsonBody.phone = this.state.phone
    if(this.state.ac) jsonBody.ac = this.state.ac
    if(this.loginParams) {
      if(this.loginParams.utm_source) jsonBody.utm_source = this.loginParams.utm_source // eslint-disable-line camelcase
      if(this.loginParams.utm_medium) jsonBody.utm_medium = this.loginParams.utm_medium // eslint-disable-line camelcase
      if(this.loginParams.utm_campaign) jsonBody.utm_campaign = this.loginParams.utm_campaign // eslint-disable-line camelcase
      if(this.loginParams.referer) jsonBody.referer = this.loginParams.referer
    }
    const options = {
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'selfonboard']),
      jsonBody
    }
    if(phone) options.jsonBody.phone = phone
    ApiHelper.call(options, function (err, data) {
      if (err) {
        this.setState({
          message: Helper.getErrorMsg(err),
          loadingAnimation: false
        });
        return
      }
      Controller.get().loginMgr()._fetchAppUser((err, data) => {
        if (err) {
          this.setState({
            message: Helper.getErrorMsg(err),
            loadingAnimation: false
          });
          return
        }
        this.props.onSuccessLogin()
        // window.location.href = Controller.get().roleHelper().getHome()
      })
    }.bind(this))
  }

  render() {
    return (
      <div className={css(Styles.container)}>
        <div className={css([Styles.loginPanel, this.props.loginPanelStyle])}>

          <HelmetComponent page={'login'} />

          {this.state.currentPage === UiLoginHelper.Page.LOOKUP &&
            <h2 className={css(Styles.loginTitle)}>{Helper.getString('login')}</h2>
          }
          {this.state.currentPage === UiLoginHelper.Page.PROFILE_COMPLETION &&
            <h2 className={css(Styles.loginTitle)}>{Helper.getString('letUsKnowYou')}</h2>
          }
          <div className={css(Styles.loginMessageContainer)}>
            {this.state.message.length > 0 &&
              <p className={css(Styles.loginMessage)}>{this.state.message}</p>
            }
          </div>

          {this.state.currentPage === UiLoginHelper.Page.LOOKUP &&
            this.welcomeView()
          }
          {this.state.currentPage === UiLoginHelper.Page.PROFILE_COMPLETION &&
            this.profileCompletionView()
          }
          {this.state.currentPage === UiLoginHelper.Page.SIGNUP &&
            this.signUpView()
          }
          {this.state.currentPage === UiLoginHelper.Page.SIGNUP_OTP &&
            this.signUpOTPView()
          }
          {this.state.currentPage === UiLoginHelper.Page.LOGIN &&
            this.loginView()
          }
          {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD &&
            this.resetPasswordView()
          }
          {this.state.currentPage === UiLoginHelper.Page.RESET_PASSWORD_OTP &&
            this.resetPasswordOTPView()
          }
        </div>
      </div>
    );
  }

  //AppConfig.PRIVACY is it present in appconfig?
  welcomeView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          inputImage={require('../../assets/images/sms.svg')}
          placeholder={'Email'}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLookup()
            }
          }}
        />
        {this.props.showTerms &&
          <div className={css(Styles.termsContainer)}>
            <span>By continuing, you agree to our </span><a className={css(Styles.termsContainer, Styles.termsContainerLink)} href={AppConfig.TERMS} target='_blank'>Terms</a> and <a className={css(Styles.termsContainer, Styles.termsContainerLink)} href={AppConfig.PRIVACY} target='_blank'>Privacy policy</a>
          </div>
        }
        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitLookup.bind(this.loginHelper)}
            buttonText={'Continue'} //continue
            inProcess={this.state.loadingAnimation}
          />
        </div>
      </div>
    )
  }

  profileCompletionView() {
    return (
      <div>
        <PlainTextInput
          id='givenname'
          label={Helper.getString('firstName')}
          value={this.state.givenname}
          onChange={(event) => this.setState({ givenname: event.target.value })}
          inputImage={require('../../assets/images/buildings-2.svg')}
          placeholder={Helper.getString('firstName')}
        />
        <PlainTextInput
          id='familyname'
          label={Helper.getString('lastName')}
          value={this.state.familyname}
          onChange={(event) => this.setState({ familyname: event.target.value })}
          inputImage={require('../../assets/images/buildings-2.svg')}
          placeholder={Helper.getString('lastName')}
        />
        <PlainTextInput
          id='title'
          label={'Business/Company name'}
          value={this.state.title}
          onChange={(event) => this.setState({ title: event.target.value })}
          inputImage={require('../../assets/images/shop.svg')}
          placeholder={'Your business name'}
        />
        <PlainTextInput
          id='phone'
          label={Helper.getString('phone')}
          value={this.state.phone}
          onChange={(event) => this.setState({ phone: event.target.value })}
          inputImage={require('../../assets/images/call.svg')}
          placeholder={Helper.getString('phone')}
          type={'tel'}
        />
        <PlainTextInput
          id='ac'
          label={Helper.getString('ac')}
          value={this.state.ac}
          onChange={(event) => this.setState({ ac: event.target.value })}
          inputImage={require('../../assets/images/document.svg')}
          placeholder={Helper.getString('ac')}
        />
        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            onClick={this.onSelfOnBoard}
            buttonText={'Continue'} //continue
            inProcess={this.state.loadingAnimation}
          />
        </div>
      </div>
    )
  }

  signUpView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          inputImage={require('../../assets/images/sms.svg')}
        />


        <PasswordInput
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          placeholder='Set a new password'
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUp()
            }
          }}
          inputImage={require('../../assets/images/lock.svg')}
        />
        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            buttonText={'Signup'}
            onClick={this.loginHelper.onSubmitSignUp.bind(this.loginHelper)}
          />
        </div>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  signUpOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })}
          inputImage={require('../../assets/images/lock.svg')}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitSignUpConfirm()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitSignUpConfirm.bind(this.loginHelper)}
            buttonText={'Submit'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  loginView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          inputImage={require('../../assets/images/sms.svg')}
        />

        <PasswordInput
          id='pword'
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitLogin()
            }
          }}
          inputImage={require('../../assets/images/lock.svg')}
        />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitLogin.bind(this.loginHelper)}
            buttonText={'Continue'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onResetPasswordClicked.bind(this)}><p>Reset password? Get OTP</p></a>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    );
  }

  resetPasswordView() {
    return (
      <div>
        <UsernameInput
          id='userName'
          value={this.state.userName}
          userNameType={this.userNameType}
          onChange={(event) => this.setState({ userName: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitResetPassword()
            }
          }}
          inputImage={require('../../assets/images/sms.svg')}
        />


        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitResetPassword.bind(this.loginHelper)}
            buttonText={'Get OTP'}
          />
        </div>

        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  resetPasswordOTPView() {
    return (
      <div>
        <NumericOTPInput
          id='verificationCode'
          value={this.state.verificationCode}
          onChange={(event) => this.setState({ verificationCode: event.target.value })} />

        <PasswordInput
          id='pword'
          value={this.state.pword}
          onChange={(event) => this.setState({ pword: event.target.value })}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              this.loginHelper.onSubmitConfirmResetPassword()
            }
          }} />

        <div className={css(Styles.buttonContainer)}>
          <AppButton
            buttonStyle={Styles.button}
            disabled={this.state.loadingAnimation}
            inProcess={this.state.loadingAnimation}
            onClick={this.loginHelper.onSubmitConfirmResetPassword.bind(this.loginHelper)}
            buttonText={'Submit'}
          />
        </div>
        <a className={css(Styles.loginLink)} onClick={this.onStartoverClicked.bind(this)}><p>Start over</p></a>
      </div>
    )
  }

  onStartoverClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.LOOKUP);
  }

  onResetPasswordClicked() {
    this.loginHelper.toPage(UiLoginHelper.Page.RESET_PASSWORD);
  }
}

const Styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFFFFF',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  loginPanel: {
    borderRadius: 40,
    backgroundColor: '#FFFFFF',
    textAlign: 'left',
    padding: 40,
    '@media (max-width: 767px)': {
      padding: 20,
      margin: 5,
    },
    '@media (max-width: 320px)': {
      padding: 20,
      margin: 5
    }
  },
  loginMessageContainer: {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  loginMessage: {
    marginTop: 10,
    fontSize: 14,
    color: 'red'
  },
  loginLink: {
    marginTop: 10,
    cursor: 'pointer',
    color: 'black',
    fontSize: 14
  },
  buttonContainer: {
    display: 'flex',
    flex: 1,
    marginTop: 20
  },
  marginLeft: {
    marginLeft: 10
  },
  termsContainer: {
    marginTop: 24,
    fontSize: 12,
    color: '#BBBBBB',
    lineHeight: '16px',
    fontWeight: 400,
    marginBottom: 20,
    '@media (max-width: 767px)': {
      marginTop: 14,
      marginBottom: 14,
    },
  },
  termsContainerLink: {
    color: AppConfig.TINT_COLOUR,
    cursor: 'pointer'
  },
  buttonStyle: {
    boxShadow: 'none',
    backgroundColor: AppTheme.buttonBg,
    color: AppTheme.buttonTextColor,
    borderRadius: AppTheme.pagePadding,
    textAlign: 'center',
    letterSpacing: 0,
    textTransform: 'uppercase',
    opacity: 1,
  },
  button: {
    flex: 1,
    height: 54,
    minHeight: 54,
    backgroundColor: AppConfig.TINT_COLOUR
  },
  loginTitle: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '37px',
    color: '#1B1B1B',
    margin: 0,
    marginBottom: 26,
    '@media (max-width: 767px)': {
      fontSize: 18,
      lineHeight: '24px',
      marginBottom: 20,
    },
  },
  loginDescr: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '26px',
    color: '#1B1B1B',
    margin: 0,
    marginBottom: 40,
    '@media (max-width: 767px)': {
      fontSize: 14,
      lineHeight: '19px',
      marginBottom: 34,
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/advertiser/LoginCustomAdv.js